<template>
  <div id="dynamic_grid">
    <el-table
      :data="data"
      border
      header-row-class-name="grid_header"
      style="width: 100%"
      max-height="380"
    >
      <el-table-column class-name="actions" fixed="left" width="32">
        <template #default="scope">
          <el-icon
            @click="store.commit('api/delete_gridline', { view: props.vmodel, grid: props.meta.f, row: scope.$index + tablestart })"
          >
            <Delete />
          </el-icon>
        </template>
      </el-table-column>
      <el-table-column
        class-name="index"
        fixed="left"
        type="index"
        width="40"
        :index="indexCounter"
      />

      <el-table-column
        v-for="col in props.meta.c"
        :label="col.text || col.f"
        :key="col.f"
        :prop="col.f"
        :min-width="col.w"
      >
        <template #default="scope">
          <div v-if="col.f == 'value'">
            <div v-if="scope.row['type']  == 'CharField' || scope.row['type']  == 'ForeignKey'" style="height: 100%;">
              <div v-if="col.m !== null && col.m" style="height: 100%;">
                <input
                  :value="scope.row[col.f]"
                  class="input_affix"
                  @change="after_edit(scope.$index + tablestart, col.f, $event.target.value)"
                />
                <el-icon
                  class="el-input__icon"
                  @click="openSelect(col.m, col.f, scope.$index + tablestart)"
                  style="position: absolute;right: 0; z-index: 99;top: 0; color: rgb(192, 196, 204);"
                >
                  <Search />
                </el-icon>
              </div>
              <div v-else style="height: 100%;">
                <input
                  :value="scope.row[col.f]"
                  @change="after_edit(scope.$index + tablestart, col.f, $event.target.value)"
                />
              </div>
            </div>
            <div v-else-if="scope.row['type']  == 'BooleanField'">
              <el-checkbox
                v-model="scope.row[col.f]"
                @change="after_edit(scope.$index + tablestart, col.f, scope.row[col.f])"
                size="medium"
              ></el-checkbox>
            </div>
            <div v-else-if="scope.row['type']  == 'DropdownInteger'">
              <el-select v-model="scope.row[col.f]"
                @change="after_edit(scope.$index + tablestart, col.f, $event)">
                <el-option
                  v-for="item in menus[col.menu]"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>
            <div v-else-if="scope.row['type']  == 'DateField'">
              <el-date-picker
                v-model="scope.row[col.f]"
                type="date"
                value-format="YYYY-MM-DD"
                format="DD.MM.YYYY"
                :clearable="clearable"
                @change="after_edit(scope.$index + tablestart, col.f, $event)"
              ></el-date-picker>
            </div>
            <div v-else-if="scope.row['type']  == 'DecimalField'" style="height: 100%;">
              <input
                type="number"
                :value="scope.row[col.f]"
                @change="after_edit(scope.$index + tablestart, col.f, $event.target.value)"
              />
            </div>
            <div v-else style="height: 100%;">
              <input
                :value="scope.row[col.f]"
                @change="after_edit(scope.$index + tablestart, col.f, $event.target.value)"
              />
            </div>
          </div>
          <div v-else style="height: 100%;">
            <input :value="scope.row[col.f]" @change="after_edit(scope.$index + tablestart, col.f, $event.target.value)" />
          </div>
        </template>
      </el-table-column>
    </el-table>

    <div style="margin-left: 10px;cursor: pointer; width: 30px; float: left; margin-top:5px;">
      <el-icon @click="addRow">
        <Plus />
      </el-icon>
    </div>

    <el-pagination
      :pager-count="9"
      :page-size="perPage"
      :total="total_records"
      @current-change="current_page"
      layout="prev, pager, next"
      :small="true"
      :hide-on-single-page="true"
      background
      style="margin-left: 10px;width: auto; float: right; margin-top:5px;"
    ></el-pagination>
  </div>
</template>


<script>
import { messages } from '@/popups';
import { Delete, Plus, Search } from "@element-plus/icons";
import { computed, inject, ref } from "vue";
import { apiHelpers } from "../helpers";
import { uiHelpers } from "../ui_helpers";
export default {
  name: "ModelDetails",
  components: {
    Search, Delete, Plus
  },
  props: {
    meta: Object,
    vmodel: String
  },
  setup(props) {
    const { store } = apiHelpers(props);
    const { menus } = uiHelpers(props);
    const select_model = inject("select_model");
    const current_detail_store = inject("current_detail_store");
    const currentfield = inject("currentfield");
    const currentrow = inject("currentrow");
    const currentgrid = inject("currentgrid");
    const lookupvisible = inject("lookupvisible");
    const currentPage = ref(1)
    const perPage = ref(10)
    const { showerorr } = messages()
    const addRow = () => {
      store.commit("api/add_row", {vmodel: props.vmodel,grid: props.meta.f})
    };
    const openSelect = async (m, f, r) => {
      select_model.value = m;
      currentfield.value = f;
      current_detail_store.value = props.vmodel
      currentrow.value = r;
      currentgrid.value = props.meta.f
      lookupvisible.value = !lookupvisible.value;
    };
    // const data = computed(() => store.state.api[props.vmodel][props.meta.f])
    const tablestart = computed(() => (currentPage.value - 1) * perPage.value)

    const total_records = computed(() => {
      if (store.state.api[props.vmodel][props.meta.f]) {
        return store.state.api[props.vmodel][props.meta.f].length
      } else {
        return 0
      }
    })

    const data = computed(() => {
      if (store.state.api[props.vmodel][props.meta.f]) {
        return store.state.api[props.vmodel][props.meta.f].slice(tablestart.value, tablestart.value + perPage.value)
      } else {
        return []
      }
    })
    const current_page = async (current) => {
      currentPage.value = current
    }
    const indexCounter = (index) => {
      return index + tablestart.value + 1
    }


    const after_edit = (row, field, value) => {
      store.dispatch('api/after_edit', { grid: props.meta.f, row: row, field: field, value: value, view: props.vmodel })
        .then(() => { })
        .catch(err => {
          showerorr(err)
        })
    }

    const controls = ref(false)
    const clearable = ref(false)
    const prefix_icon = ref(null)
    const min = ref(null)
    return {
      data,
      props,
      openSelect,
      store,
      addRow,
      controls,
      clearable,
      prefix_icon,
      min,
      perPage,
      total_records,
      current_page,
      tablestart,
      indexCounter,
      after_edit,
      menus
    };
  },
};
</script>

<style>
#dynamic_grid .el-table__cell {
  padding: 0 !important;
  margin: 0 !important;
  height: 32px;
}
#dynamic_grid .cell {
  padding: 0 !important;
  margin: 0 !important;
  height: 32px;
  font-size: 0.9em;
}
#dynamic_gridgrid .el-input {
  padding: 0 !important;
  margin: 0 !important;
  height: 32px;
}
#dynamic_grid input {
  height: 100%;
  width: 100%;
  margin: 0 !important;
  border: none;
  border-radius: 0;
  --webkit-border-radius: 0;
  color: #606266;
  background-color: inherit;
}

.cell input.input_affix {
  padding: 0 25px 0 5px !important;
}

.cell input:not(.input_affix) {
  padding: 0 5px 0 5px !important;
}

.cell .el-input--prefix input {
  padding: 0 5px 0 30px !important;
}

#dynamic_grid .el-checkbox__inner {
  margin: 0 10px !important;
}
#dynamic_grid {
  padding: 0 5px;
}
#dynamic_grid .grid_header .is-leaf {
  padding: 5px;
  background-color: #fbfbfb;
}

#dynamic_grid .grid_header .is-leaf .cell {
  padding: 4px !important;
}
#dynamic_grid .actions .cell,
#dynamic_grid .index .cell {
  padding: 3px 8px !important;
  background-color: #fbfbfb;
}
#dynamic_grid .actions,
#dynamic_grid .index {
  background-color: #fbfbfb;
}
#dynamic_grid .actions {
  cursor: pointer;
}
input {
  font-size: 12px !important;
}
</style>
